import { useTranslation } from 'react-i18next';
import { useLoginWatcher } from '@/shared/hooks/useLoginWatcher';

export default function SessionWatcher() {
  const { t } = useTranslation();
  const { loginStatus, setLoginStatus } = useLoginWatcher();

  if (!loginStatus) return null;

  const message = loginStatus === 'login' ? t('cm > session window') : t('cm > session logout');

  return (
    <div
      role="alert"
      aria-live="polite"
      className="fixed top-4 left-1/2 -translate-x-1/2 bg-yellow-100 border border-yellow-400 text-yellow-800 px-4 py-2 rounded shadow flex items-center gap-2"
    >
      <span>{message}</span>
      <button
        type="button"
        onClick={() => {
          window.location.reload();
          setLoginStatus(null);
        }}
        className="underline font-semibold hover:text-yellow-900"
      >
        {t('Refresh>master>refresh')}
      </button>
    </div>
  );
}
